(ns vit-configurator.views.voter-info
  (:require [re-frame.core :as re-frame]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]))

(defn vip-spec-link []
  [:a {:href "https://vip-specification.readthedocs.io/en/latest/index.html"} "VIP 5.2 specification"])

(defn civic-info-link []
  [:a {:href "https://developers.google.com/civic-information"} "Google Civic Information API"])

(defn legend-text []
  [:legend
   [:p
    "Shows an urgent message before users can access results.
    Since this message text is English-only and can only be updated by changing embed code,
    we work with election offices whenever possible to use the Election Notice added in the "
    (vip-spec-link)
    " which is easier to change and appears in most applications using the "
    (civic-info-link)
    "."]
   [:p "Note: Avoid using this message for less than urgent guidance
    because users may not click through to location results when shown a message first."]])

(defn customizer
  []
  (let [voter-info @(re-frame/subscribe [::subs/voter-info])]
    [:fieldset#voter-info-message
     (legend-text)
     [:label.pr-4 {:for "message"} "Voter Info Message"]
     [:div
      [:input.mb-0.mw-100
       {:type "text"
        :name "voter-info"
        :value voter-info
        :id "message"
        :on-change (fn [evt]
                     (let [val (.. evt -target -value)]
                       (re-frame/dispatch [::events/set-voter-info val])))}]]]))
